"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "totalRecords": 23,
    "skip": 0,
    "take": 100,
    "recordsReturned": 23,
    "data": [
        {
            "transactionKey": "tran_a780f9e196cd4d4f98b8942c087991cb",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "ANZ.ASX",
            "securityName": "Australia & New Zealand Banking Group Ltd.",
            "description": "Transfer In - 4219 x ANZ",
            "type": "TransferIn",
            "tradeDate": "2021-01-01T00:00:00",
            "units": 4219.000000,
            "price": 28.15000000,
            "transactionValue": 118764.85000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 118764.85
        },
        {
            "transactionKey": "tran_a4e7568f26a64496994f79feab387b73",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "ANZ.ASX",
            "securityName": "Australia & New Zealand Banking Group Ltd.",
            "description": "Transfer In - 3403 x ANZ",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 3403.000000,
            "price": 28.15000000,
            "transactionValue": 95794.45000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 95794.45
        },
        {
            "transactionKey": "tran_d1b5ad4826f140f18e9c75d2f42e183c",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "ANZPG.ASX",
            "securityName": "ANZ Capital Notes 4",
            "description": "Transfer In - 500 x ANZPG",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 500.000000,
            "price": 106.95000000,
            "transactionValue": 53475.00000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 53475.00
        },
        {
            "transactionKey": "tran_45460de5a92449ba8c9a2f2097ce12db",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "ANZPG.ASX",
            "securityName": "ANZ Capital Notes 4",
            "description": "Transfer In - 1306 x ANZPG",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 1306.000000,
            "price": 106.95000000,
            "transactionValue": 139676.70000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 139676.70
        },
        {
            "transactionKey": "tran_e0e7b93772d54c3090e4df36749fd64b",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "ANZPG.ASX",
            "securityName": "ANZ Capital Notes 4",
            "description": "Transfer In - 1531 x ANZPG",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 1531.000000,
            "price": 106.95000000,
            "transactionValue": 163740.45000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 163740.45
        },
        {
            "transactionKey": "tran_b4f7c9da31ce4c3d8c25fd51e094d384",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "APL.ASX",
            "securityName": "Antipodes Global Investment Company Limited",
            "description": "Transfer In - 110667 x APL",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 110667.000000,
            "price": 1.12000000,
            "transactionValue": 123947.04000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 123947.04
        },
        {
            "transactionKey": "tran_2bb08708de3a4f7ab12ff10120846e35",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "APL.ASX",
            "securityName": "Antipodes Global Investment Company Limited",
            "description": "Transfer In - 9998 x APL",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 9998.000000,
            "price": 1.12000000,
            "transactionValue": 11197.76000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 11197.76
        },
        {
            "transactionKey": "tran_334086f3456746e780ce1956ec03c214",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "APL.ASX",
            "securityName": "Antipodes Global Investment Company Limited",
            "description": "Transfer In - 117131 x APL",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 117131.000000,
            "price": 1.12000000,
            "transactionValue": 131186.72000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 131186.72
        },
        {
            "transactionKey": "tran_86d0e4e0b9f34ce78f872205dd319470",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "APT.ASX",
            "securityName": "Afterpay Limited",
            "description": "Transfer In - 85 x APT",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 85.000000,
            "price": 118.17000000,
            "transactionValue": 10044.45000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 10044.45
        },
        {
            "transactionKey": "tran_93152ca4563b49819b777e6ee0026b67",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "APT.ASX",
            "securityName": "Afterpay Limited",
            "description": "Transfer In - 304 x APT",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 304.000000,
            "price": 118.17000000,
            "transactionValue": 35923.68000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 35923.68
        },
        {
            "transactionKey": "tran_b354d41e7b6948769b95e39fd9436ecc",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "BBT.ASX",
            "securityName": "BlueBet Holdings Ltd",
            "description": "Transfer In - 11403 x BBT",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 11403.000000,
            "price": 1.00000000,
            "transactionValue": 11403.00000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 11403.00
        },
        {
            "transactionKey": "tran_350256b02c874044a373f3bd02b1846b",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "BENPH.ASX",
            "securityName": "Bendigo and Adelaide Bank Ltd",
            "description": "Transfer In - 1756 x BENPH",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 1756.000000,
            "price": 105.50000000,
            "transactionValue": 185258.00000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 185258.00
        },
        {
            "transactionKey": "tran_dd195de70ddf4756ad2cdd5e953689a8",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "BET.ASX",
            "securityName": "BetMakers Technology Group Limited",
            "description": "Transfer In - 75516 x BET",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 75516.000000,
            "price": 1.07000000,
            "transactionValue": 80802.12000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 80802.12
        },
        {
            "transactionKey": "tran_3939b881cca54d26ae31ddab2157e9ed",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "BHP.ASX",
            "securityName": "BHP Group Limited",
            "description": "Transfer In - 757 x BHP",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 757.000000,
            "price": 48.57000000,
            "transactionValue": 36767.49000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 36767.49
        },
        {
            "transactionKey": "tran_499b9874268745f8ae53375f2f8af041",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "BHP.ASX",
            "securityName": "BHP Group Limited",
            "description": "Transfer In - 1415 x BHP",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 1415.000000,
            "price": 48.57000000,
            "transactionValue": 68726.55000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 68726.55
        },
        {
            "transactionKey": "tran_384060b7c5644808ab8e183ecce2686f",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "CBA.ASX",
            "securityName": "Commonwealth Bank of Australia",
            "description": "Transfer In - 1527 x CBA",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 1527.000000,
            "price": 99.87000000,
            "transactionValue": 152501.49000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 152501.49
        },
        {
            "transactionKey": "tran_edfcf0ad0129496eb3105d0e4c2c6598",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "CBA.ASX",
            "securityName": "Commonwealth Bank of Australia",
            "description": "Transfer In - 63 x CBA",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 63.000000,
            "price": 99.87000000,
            "transactionValue": 6291.81000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 6291.81
        },
        {
            "transactionKey": "tran_bcf33f5208214afaad7b694473b44095",
            "accountKey": "fa_bde96750bcc64d9982a564c85f14166b",
            "securityCode": "MacqBankCMA.ADI",
            "securityName": "Macquarie Bank CMA ",
            "description": "Opening Balance",
            "type": "TransferIn",
            "tradeDate": "2021-10-01T00:00:00",
            "units": 1000000.000000,
            "price": 1.00000000,
            "transactionValue": 1000000.00000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 1000000.00
        },
        {
            "transactionKey": "tran_33743b71eb45420b93c61387916f9bc7",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "AQZ.ASX",
            "securityName": "Alliance Aviation Services Limited",
            "description": "Transfer In - 6580 x AQZ",
            "type": "TransferIn",
            "tradeDate": "2022-03-01T00:00:00",
            "units": 6580.000000,
            "price": 4.55000000,
            "transactionValue": 29939.00000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 29939.00
        },
        {
            "transactionKey": "tran_b1710267b0fc49f885db8313cd0d90a4",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "ASB.ASX",
            "securityName": "Austal Ltd.",
            "description": "Transfer In - 10548 x ASB",
            "type": "TransferIn",
            "tradeDate": "2022-03-02T00:00:00",
            "units": 10548.000000,
            "price": 2.05000000,
            "transactionValue": 21623.40000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 21623.40
        },
        {
            "transactionKey": "tran_42a1f88a21c44649bfb3b1d5cdb3fd50",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "ABC.ASX",
            "securityName": "Adbri Limited",
            "description": "Buy 1000 ABC.ASX",
            "type": "Buy",
            "tradeDate": "2022-03-03T00:00:00",
            "units": 1000.000000,
            "price": 3.00000000,
            "transactionValue": 3000.00000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 3000.00
        },
        {
            "transactionKey": "tran_6350464f852e474bac2ce6761da666c0",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "APT.ASX",
            "securityName": "Afterpay Limited",
            "description": "Transfer In - 5795 x APT",
            "type": "TransferIn",
            "tradeDate": "2022-03-08T00:00:00",
            "units": 5795.000000,
            "price": 118.17000000,
            "transactionValue": 684795.15000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 684795.15
        },
        {
            "transactionKey": "tran_b3a9211f11d44cef981afd2687008ea9",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "ANZ.ASX",
            "securityName": "Australia & New Zealand Banking Group Ltd.",
            "description": "Transfer In - 192 x ANZ",
            "type": "TransferIn",
            "tradeDate": "2022-03-21T00:00:00",
            "units": 192.000000,
            "price": 28.15000000,
            "transactionValue": 5404.80000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 5404.80
        }
    ]
};
